import React from 'react';
import { Flex, Text } from '@vibe/core';
import { format, parseISO } from 'date-fns';
import { TimesheetStatusBadge } from './TimesheetStatusBadge';
import type { TimesheetSubmission } from '../../types/timesheet-approval.types';
import { formatHoursMinutes } from '../../utils/timesheet-capacity';

export interface TimesheetListRowProps {
  submission: TimesheetSubmission;
  userName?: string;
  isSelected: boolean;
  onClick: () => void;
}

function formatPeriodShort(start: string, end: string): string {
  try {
    return `${format(parseISO(start), 'MMM d')} - ${format(parseISO(end), 'MMM d')}`;
  } catch {
    return `${start} - ${end}`;
  }
}

const TimesheetListRow: React.FC<TimesheetListRowProps> = ({
  submission,
  userName,
  isSelected,
  onClick,
}) => {
  return (
    <button
      className={`rp-ts-list-row ${isSelected ? 'rp-ts-list-row--selected' : ''}`}
      onClick={onClick}
    >
      <Flex gap={Flex.gaps.SMALL} align={Flex.align.CENTER}>
        <div className="rp-ts-list-row__info">
          <Text type={Text.types.TEXT1} weight={Text.weights.MEDIUM}>
            {userName ?? `User ${submission.userId}`}
          </Text>
          <Text type={Text.types.TEXT2} color={Text.colors.SECONDARY}>
            {formatPeriodShort(submission.periodStart, submission.periodEnd)}
          </Text>
        </div>

        <Text type={Text.types.TEXT1} weight={Text.weights.BOLD} style={{ color: '#0073ea' }}>
          {formatHoursMinutes(Number(submission.totalHours))}
        </Text>

        <TimesheetStatusBadge status={submission.status} />
      </Flex>
    </button>
  );
};

export default TimesheetListRow;
